// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3aIwG","modalForm":"UpgradeEpcsModal_modalForm__2hFpl","modalFooter":"UpgradeEpcsModal_modalFooter__3umY0"};